module.exports = __webpack_public_path__ + "static/4101-c14d7d9f8c84fc374bcd31055ece1335.png";